import { Controller } from "@hotwired/stimulus"

// Triggers the browser print dialog. Combined with `.d-print-none` and the
// `@media print` rules in application.scss, this lets quote/receipt pages
// double as "Print to PDF" / thermal-printer output without a PDF gem.
export default class extends Controller {
  trigger() {
    window.print()
  }
}
